import axios from 'axios'

export default {
    async create(model) {
        return await axios.post(`fleet`, model)
    },
    async fetchById(id) {
        return await axios.get(`fleet/${id}`)
    },
    async fetch(query, page) {
        return await axios.get(`fleet?q=${query}&page=${page}`)
    },
    async fetchDrivers() {
        return await axios.get(`user`)
    },
    async fetchWarehouses() {
        return await axios.get(`warehouse`)
    },
    async update(id, model) {
        return await axios.put(`fleet/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`fleet/${id}`)
    },
}
